import { useMemo } from "react";
import apiClient from "./apiClient";

export type SystemAlias = {
  alias: string;
  systemCode: string;
  imageSet?: string | null;
  commonName?: string | null;
  createdAt?: string;
  updatedAt?: string;
};

export type SystemAliasInput = {
  alias: string;
  systemCode: string;
  imageSet?: string | null;
  commonName?: string | null;
};

export type SystemAliasUpdate = Partial<Omit<SystemAliasInput, "alias">>;

export const useAliasApi = () => {
  return useMemo(() => {
    return {
      listAliasesApi: async (systemCode?: string): Promise<SystemAlias[]> => {
        const { data } = await apiClient.get(`/alias`, {
          params: systemCode ? { systemCode } : undefined,
        });
        return (data?.aliases as SystemAlias[]) || [];
      },

      createAliasApi: async (input: SystemAliasInput): Promise<SystemAlias> => {
        const { data } = await apiClient.post(`/alias/create`, input);
        return data.alias as SystemAlias;
      },

      updateAliasApi: async (
        alias: string,
        update: SystemAliasUpdate,
      ): Promise<void> => {
        await apiClient.put(`/alias`, { alias, ...update });
      },

      deleteAliasApi: async (alias: string): Promise<void> => {
        await apiClient.delete(`/alias/${encodeURIComponent(alias.toLowerCase())}`);
      },
    };
  }, []);
};
